// extracted by mini-css-extract-plugin
module.exports = {"filterWrapper":"tvG9I","filterHeader":"_1OADx","filterContent":"_2nQGF","footerWrapper":"_2-7tP"};